<template>
  <TrainingsList />
</template>

<script>
import TrainingsList from '@/components/content/education/training/EditTrainingsPage'

export default {
  name: 'ContentTrainings',
  components: { TrainingsList }
}
</script>

<style scoped>

</style>
